(() => {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery || typeof HTMLDialogElement === 'undefined') return;

  const SWIPE_PX = 48;
  const TAP_MOVE_PX = 12;

  const dialog = document.createElement('dialog');
  dialog.className = 'hp-pdp-zoom';
  dialog.setAttribute('aria-label', 'Ürün görselleri');
  dialog.innerHTML = `
    <div class="hp-pdp-zoom__panel">
      <header class="hp-pdp-zoom__header">
        <span class="hp-pdp-zoom__counter" data-counter></span>
        <button type="button" class="hp-pdp-zoom__close" data-close aria-label="Kapat">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" aria-hidden="true">
            <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
          </svg>
        </button>
      </header>
      <div class="hp-pdp-zoom__stage" data-stage>
        <div class="hp-pdp-zoom__content" data-content>
          <figure class="hp-pdp-zoom__figure">
            <img class="hp-pdp-zoom__img" data-img alt="" decoding="async" />
          </figure>
        </div>
      </div>
      <div class="hp-pdp-zoom__controls" data-controls hidden>
        <button type="button" class="hp-pdp-zoom__nav hp-pdp-zoom__nav--prev" data-prev aria-label="Önceki görsel">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m15 18-6-6 6-6"/>
          </svg>
        </button>
        <span class="hp-pdp-zoom__controls-counter" data-controls-counter></span>
        <button type="button" class="hp-pdp-zoom__nav hp-pdp-zoom__nav--next" data-next aria-label="Sonraki görsel">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>
      </div>
    </div>
  `;
  document.body.appendChild(dialog);

  const counterEl = dialog.querySelector('[data-counter]');
  const controlsCounterEl = dialog.querySelector('[data-controls-counter]');
  const controlsEl = dialog.querySelector('[data-controls]');
  const imgEl = dialog.querySelector('[data-img]');
  const stageEl = dialog.querySelector('[data-stage]');
  const contentEl = dialog.querySelector('[data-content]');
  const prevBtn = dialog.querySelector('[data-prev]');
  const nextBtn = dialog.querySelector('[data-next]');
  const closeBtn = dialog.querySelector('[data-close]');

  let slides = [];
  let index = 0;
  let touchStartX = 0;

  const fullUrl = (src) => {
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.delete('width');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      return url.toString();
    } catch {
      return src;
    }
  };

  const collectSlides = () => {
    const nodes = gallery.querySelectorAll('[data-media-type="image"]:not([hidden])');
    return [...nodes].map((node) => {
      const img = node.querySelector('img');
      const thumb = img?.currentSrc || img?.src || '';
      return {
        id: node.dataset.mediaId || '',
        src: fullUrl(thumb),
        alt: img?.alt || '',
      };
    }).filter((s) => s.src);
  };

  const setImage = (slide) => {
    imgEl.classList.add('is-loading');
    const onDone = () => {
      imgEl.classList.remove('is-loading');
      imgEl.removeEventListener('load', onDone);
      imgEl.removeEventListener('error', onDone);
    };
    imgEl.addEventListener('load', onDone);
    imgEl.addEventListener('error', onDone);
    imgEl.alt = slide.alt;
    imgEl.src = slide.src;
    if (imgEl.complete) onDone();
  };

  const render = () => {
    const slide = slides[index];
    if (!slide) return;
    setImage(slide);
    const multi = slides.length > 1;
    const counterText = multi ? `${index + 1} / ${slides.length}` : '';
    counterEl.textContent = counterText;
    if (controlsCounterEl) controlsCounterEl.textContent = counterText;
    if (controlsEl) controlsEl.hidden = !multi;
    prevBtn.disabled = !multi || index <= 0;
    nextBtn.disabled = !multi || index >= slides.length - 1;
  };

  const go = (delta) => {
    if (slides.length < 2) return;
    index = Math.max(0, Math.min(slides.length - 1, index + delta));
    render();
  };

  const open = (mediaId) => {
    slides = collectSlides();
    if (!slides.length) return;
    index = slides.findIndex((s) => s.id === String(mediaId));
    if (index < 0) index = 0;
    render();
    if (!dialog.open) dialog.showModal();
  };

  const close = () => {
    if (dialog.open) dialog.close();
    imgEl.removeAttribute('src');
  };

  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', () => go(-1));
  nextBtn.addEventListener('click', () => go(1));

  stageEl.addEventListener('click', (event) => {
    if (contentEl?.contains(event.target)) return;
    close();
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });

  dialog.addEventListener('close', () => {
    imgEl.removeAttribute('src');
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      go(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      go(1);
    }
  });

  stageEl.addEventListener(
    'touchstart',
    (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? 0;
    },
    { passive: true }
  );

  stageEl.addEventListener(
    'touchend',
    (event) => {
      const endX = event.changedTouches[0]?.clientX ?? 0;
      const dx = endX - touchStartX;
      if (Math.abs(dx) < SWIPE_PX) return;
      go(dx > 0 ? -1 : 1);
    },
    { passive: true }
  );

  const resolveMediaId = (target) => {
    const zoomHost =
      target.closest('[data-hp-pdp-zoom="true"]') ||
      target.closest('.product-media-grid__item');
    if (!zoomHost || !gallery.contains(zoomHost)) return null;
    if (target.closest('a, button, [data-hp-pdp-zoom-ignore]')) return null;
    const media = zoomHost.querySelector('[data-media-type="image"]');
    return media?.dataset.mediaId || null;
  };

  let tapStartX = 0;
  let tapStartY = 0;
  let tapMoved = false;

  gallery.addEventListener(
    'pointerdown',
    (event) => {
      tapStartX = event.clientX;
      tapStartY = event.clientY;
      tapMoved = false;
    },
    true
  );

  gallery.addEventListener(
    'pointermove',
    (event) => {
      if (tapMoved) return;
      if (
        Math.abs(event.clientX - tapStartX) > TAP_MOVE_PX ||
        Math.abs(event.clientY - tapStartY) > TAP_MOVE_PX
      ) {
        tapMoved = true;
      }
    },
    true
  );

  gallery.addEventListener(
    'click',
    (event) => {
      if (tapMoved) return;
      const mediaId = resolveMediaId(event.target);
      if (!mediaId) return;
      event.preventDefault();
      event.stopPropagation();
      open(mediaId);
    },
    true
  );
})();
